<template>
  <div class="applets">
    <div class="relative">
      <div class="decoration-common__style">
        <div class="hd-title clearfix">
          <span class="intro">装修方式：</span>
          <span class="txt">
            {{ decorationMethod == '1' ? '酒加模版' : '第三方模版' }}
          </span>
          <span class="intro">小程序名称：</span>
          <span class="txt">
            {{
              appletsName | formatLabelName(filterDownData('appletsList')) ||
              $route.query.title
            }}
          </span>
          <span class="intro"> 装修页面名称：</span>
          <span class="txt">
            {{ renovationName || $route.query.renovationName }}
          </span>
          <div class="right">
            <el-button class="sub-color" @click="openDrawer">
              {{ activeName === 0 ? ' 商品查询' : '笔记查询' }}
            </el-button>
          </div>
        </div>
        <div class="container-wrapper">
          <div class="change-view">
            <span class="btn" :class="activeName === 0 && 'active'" @click="switchComponent(0)">
              小程序首页
            </span>
            <fragment v-if="isMyMerchant">
              <span class="line" />
              <span class="btn" :class="activeName === 1 && 'active'" @click="switchComponent(1)">
                品酒笔记
              </span>
            </fragment>
          </div>
          <fragment ref="comp" :is="dynamicComponent" :home="home" :appletsId="appletsName || $route.query.appletsId"
            :renovationName="renovationName" :decorationMethod="decorationMethod" renovationType="applet" />
        </div>
        <div class="mask" v-if="dialogFormVisible">
          <el-dialog :visible.sync="dialogFormVisible" :modal-append-to-body="false" :close-on-click-modal="false"
            :close-on-press-escape="false" :show-close="false" :modal="false" custom-class="dialog" width="37.5rem"
            :center="true">
            <el-form label-width="auto">
              <el-form-item>
                <span slot="label">
                  装修方式：
                </span>
                <el-radio-group v-model="decorationMethod" @change="changeDecorationMethod($event)">
                  <el-radio label="1">酒加模板</el-radio>
                  <el-radio label="2">第三方模板</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="小程序名称：">
                <el-select v-model="appletsName" placeholder="请选择" clearable>
                  <el-option :label="item.label" :value="item.value" v-for="item in filterDownData('appletsList')"
                    :key="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item label="装修页面名称：">
                <el-input v-model="renovationName" clearable placeholder="请输入" />
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button class="sub-color" size="98" @click="selectApplets">
                确 定
              </el-button>
            </div>
          </el-dialog>
        </div>
      </div>
      <el-drawer :visible.sync="drawer" :append-to-body="false" direction="ltr" size="100%" :with-header="false"
        :modal="false">
        <fragment v-if="activeName === 0">
          <InSalesGoods />
        </fragment>
        <fragment v-else>
          <NotesEvaluation />
        </fragment>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import AppletsHome from './AppletsHome/appletsHome'
import AppletsNotes from './AppletsNotes/appletsNotes'
import filterDownData from 'mixins/filterDownData'
import InSalesGoods from 'views/GoodsManagement/InSalesGoods/inSalesGoods'
import NotesEvaluation from 'views/EvaluationManagement/NotesEvaluation/notesEvaluation'

const COMPONENTS = [AppletsHome, AppletsNotes]
export default {
  name: 'decorationApplets',
  mixins: [filterDownData],
  components: {
    InSalesGoods,
    NotesEvaluation
  },
  data() {
    return {
      appletId: '',
      drawer: false,
      activeName: 0,
      renovationName: '',
      decorationMethod: '1',
      dialogFormVisible: true,
      dynamicComponent: COMPONENTS[0],
      appletsName: '',
      home: {
        fileListBanner: {
          list: [
            {
              img: [],
              imgUrl: '',
              link: ''
            },
            {
              img: [],
              imgUrl: '',
              link: ''
            },
            {
              img: [],
              imgUrl: '',
              link: ''
            },
            {
              img: [],
              imgUrl: '',
              link: ''
            }
          ]
        },
        fileListBrandCode: {
          list: [
            {
              link: '',
              brandCode: ''
            },
            {
              link: '',
              brandCode: ''
            },
            {
              link: '',
              brandCode: ''
            },
            {
              link: '',
              brandCode: ''
            }
          ]
        },
        fileListNav: {
          list: [
            {
              img: [],
              link: '',
              name: '',
              imgUrl: ''
            },
            {
              img: [],
              link: '',
              name: '',
              imgUrl: ''
            },
            {
              img: [],
              link: '',
              name: '',
              imgUrl: ''
            },
            {
              img: [],
              link: '',
              name: '',
              imgUrl: ''
            },
            {
              img: [],
              link: '',
              name: '',
              imgUrl: ''
            },
            {
              img: [],
              link: '',
              name: '',
              imgUrl: ''
            },
            {
              img: [],
              link: '',
              name: '',
              imgUrl: ''
            },
            {
              img: [],
              link: '',
              name: '',
              imgUrl: ''
            },
            {
              img: [],
              link: '',
              name: '',
              imgUrl: ''
            },
            {
              img: [],
              link: '',
              name: '',
              imgUrl: ''
            }
          ]
        },
        fileListhotRec: {
          title: '',
          ad: '',
          list: [
            {
              img: [],
              imgUrl: '',
              link: ''
            },
            {
              img: [],
              imgUrl: '',
              link: ''
            },
            {
              img: [],
              imgUrl: '',
              link: ''
            },
            {
              img: [],
              imgUrl: '',
              link: ''
            }
          ]
        },
        fileListGroup: {
          list: [
            {
              title: '',
              ad: '',
              list: [
                {
                  img: [],
                  imgUrl: '',
                  link: ''
                },
                {
                  img: [],
                  imgUrl: '',
                  link: ''
                },
                {
                  img: [],
                  imgUrl: '',
                  link: ''
                }
              ]
            }
          ]
        },
        fileListSelected: {
          title: '',
          list: [
            {
              img: [],
              imgUrl: '',
              link: ''
            }
          ]
        },
        fileListNewProduct: {
          title: '',
          ad: '',
          list: [
            {
              img: [],
              imgUrl: '',
              link: ''
            },
            {
              img: [],
              imgUrl: '',
              link: ''
            },
            {
              img: [],
              imgUrl: '',
              link: ''
            },
            {
              img: [],
              imgUrl: '',
              link: ''
            }
          ]
        },
        fileListProducing: {
          list: [
            {
              subBanner: {
                img: [],
                imgUrl: ''
              },
              category: [
                {
                  input: '',
                  list: [
                    {
                      img: [],
                      imgUrl: '',
                      link: ''
                    },
                    {
                      img: [],
                      imgUrl: '',
                      link: ''
                    },
                    {
                      img: [],
                      imgUrl: '',
                      link: ''
                    },
                    {
                      img: [],
                      imgUrl: '',
                      link: ''
                    }
                  ]
                },
                {
                  input: '',
                  list: [
                    {
                      img: [],
                      imgUrl: '',
                      link: ''
                    },
                    {
                      img: [],
                      imgUrl: '',
                      link: ''
                    },
                    {
                      img: [],
                      imgUrl: '',
                      link: ''
                    },
                    {
                      img: [],
                      imgUrl: '',
                      link: ''
                    }
                  ]
                },
                {
                  input: '',
                  list: [
                    {
                      img: [],
                      imgUrl: '',
                      link: ''
                    },
                    {
                      img: [],
                      imgUrl: '',
                      link: ''
                    },
                    {
                      img: [],
                      imgUrl: '',
                      link: ''
                    },
                    {
                      img: [],
                      imgUrl: '',
                      link: ''
                    }
                  ]
                }
              ]
            }
          ]
        },
        fileListWineryRec: {
          list: [
            {
              img: [],
              imgUrl: '',
              name: '',
              link: '',
              discount: ''
            }
          ]
        },
        fileListSupport: {
          title: '',
          ad: '',
          list: [
            {
              img: [],
              imgUrl: '',
              name: '',
              link: '',
              intro: ''
            }
          ]
        },
        fileListAd: {
          adTime: 5,
          list: [
            {
              img: [],
              imgUrl: '',
              link: ''
            },
            {
              img: [],
              imgUrl: '',
              link: ''
            },
            {
              img: [],
              imgUrl: '',
              link: ''
            }
          ]
        },
        fileListNotesBanner: {
          list: [
            {
              img: [],
              imgUrl: '',
              link: ''
            },
            {
              img: [],
              imgUrl: '',
              link: ''
            },
            {
              img: [],
              imgUrl: '',
              link: ''
            },
            {
              img: [],
              imgUrl: '',
              link: ''
            }
          ]
        },
        fileListNotesPenfriend: {
          type: '1',
          list: [
            {
              avatar: '',
              name: '',
              id: '',
              level: ''
            },
            {
              avatar: '',
              name: '',
              id: '',
              level: ''
            },
            {
              avatar: '',
              name: '',
              id: '',
              level: ''
            },
            {
              avatar: '',
              name: '',
              id: '',
              level: ''
            }
          ]
        },
        fileListNotes: {
          active: 'find',
          field: {
            find: [
              {
                avatar: '',
                img: [],
                imgUrl: '',
                name: '',
                id: '',
                level: '',
                pelLevel: 2,
                noteId: '',
                content: ''
              }
            ],
            attention: [
              {
                avatar: '',
                img: [],
                imgUrl: '',
                name: '',
                id: '',
                level: '',
                pelLevel: 2,
                noteId: '',
                content: ''
              }
            ],
            hot: [
              {
                avatar: '',
                img: [],
                imgUrl: '',
                name: '',
                id: '',
                level: '',
                pelLevel: 2,
                noteId: '',
                content: ''
              }
            ],
            celebrity: [
              {
                avatar: '',
                img: [],
                imgUrl: '',
                name: '',
                id: '',
                level: '',
                pelLevel: 2,
                noteId: '',
                content: ''
              }
            ],
            sommelier: [
              {
                avatar: '',
                img: [],
                imgUrl: '',
                name: '',
                id: '',
                level: '',
                pelLevel: 2,
                noteId: '',
                content: ''
              }
            ],
            wineMerchant: [
              {
                avatar: '',
                img: [],
                imgUrl: '',
                name: '',
                id: '',
                level: '',
                pelLevel: 2,
                noteId: '',
                content: ''
              }
            ]
          }
        },
        fileListLimit: {
          title: '',
          list: [
            {
              img: [],
              imgUrl: '',
              link: ''
            }
          ]
        },
        fileListMoreProduct: {
          title: '',
          list: [
            {
              img: [],
              imgUrl: '',
              link: ''
            }
          ]
        },
        fileListPrice: {
          title: '价格',
          list: [
            {
              img: [],
              imgUrl: '',
              link: ''
            }
          ]
        },
        fileListManor: {
          title: '名庄',
          list: [
            {
              img: [],
              imgUrl: '',
              link: ''
            }
          ]
        },
        fileListArea: {
          title: '产地',
          list: [
            {
              img: [],
              imgUrl: '',
              link: ''
            }
          ]
        }
      }
    }
  },
  watch: {
    $route: {
      handler(to) {
        const { id, status, appletsId, decorationMethod } = to.query
        if (id) {
          this.dialogFormVisible = false
          this.appletId = appletsId
          this._getDecorationDetails({
            renovation_id: id,
            applet_id: appletsId,
            renovation_status: status,
            decoration_method: decorationMethod

          })
        }
      },
      immediate: true
    }
  },
  computed: {
    isMyMerchant() {
      return ['0', '1', '23', '27', '22', '21', '29'].includes(this.appletId)
    }
  },
  methods: {
    /**
     * 获取装修详情数据
     * @param params
     */
    _getDecorationDetails(params) {
      this.api.getDecorationDetails(params).then(res => {
        this.decorationMethod = res.renovation_info.decorationMethod.toString()
        Object.assign(this.home, res.renovation_info)
        this.$nextTick(() => {
          this.$refs.comp._addModules(this.home)
          this.$refs.comp._viewArea()
        })
      })
    },
    /**
     * 切换组件
     * @param index
     */
    switchComponent(index) {
      this.activeName = index
      this.dynamicComponent = COMPONENTS[index]
      const id = this.$route.query.id
      if (id) {
        this._getDecorationDetails({
          renovation_id: id
        })
      }
    },


    changeDecorationMethod(val) {
      this.decorationMethod = val
    },
    /**
     * 选择小程序
     */
    selectApplets() {
      if (this.appletsName === '' || this.home.decorationName === '') {
        this.$notify({
          type: 'warning',
          message: '请先选择要装修的小程序名称以及装修页面名称~！😝'
        })
        return
      }
      this.appletId = this.appletsName
      this.dialogFormVisible = false
    },
    /**
     * 打开商品查询弹窗
     */
    openDrawer() {
      this.drawer = true
    }
  }
}
</script>

<style lang="scss">
.relative {
  .el-drawer__header {
    margin: 0;
  }

  >.el-dialog__wrapper {
    bottom: 0;
    width: 35%;
    box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.2),
      0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12);

    @include maxScreenWidth(1680) {
      width: 40%;
    }

    @include maxScreenWidth(1440) {
      width: 50%;
    }

    .input-wrapper.hd {
      padding-left: 1.4rem;
    }
  }
}
</style>
